"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BasketProvider = require("./BasketProvider");
Object.keys(_BasketProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BasketProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasketProvider[key];
    }
  });
});